module.exports = __webpack_public_path__ + "images/emoji/keycap_ten.eacc20467b3587dd1a6d.png";